<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        v-if="isAlertShown"
        :class="[
          alertClass,
          'wd-z-alert wd-text-white wd-rounded wd-flex wd-align-center wd-text-base wd-px-5 wd-py-4 wd-fixed wd-z-50 wd-left-4 wd-right-4 wd-bottom-19 md:wd-top-6 md:wd-right-24 md:wd-bottom-auto md:wd-left-auto md:wd-w-100',
        ]"
      >
        <span> {{ $t(alertText) }} </span>

        <v-spacer />

        <v-btn class="close-btn" :min-width="24" :width="24" :height="24" variant="text" @click="hideAlert">
          <v-icon :size="20" color="white"> mdi-close </v-icon>
        </v-btn>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia'

import { Teleport } from 'vue'
import { useAlertStore } from '@/store-pinia/alert'
import type { AlertType } from '@/view-models/common'

const TYPES = ['error', 'success']

export default defineComponent({
  name: 'Alert',
  props: {
    text: { type: String, default: '' },
    type: { type: String, default: 'success', validator: (v: string) => TYPES.includes(v) },
  },
  emits: ['hide'],
  setup(props, { emit }) {
    const alertStore = useAlertStore()
    const { isAlertShown, alertType, alertText } = storeToRefs(alertStore)
    const { hideAlert } = alertStore

    const alertClassMap: Record<AlertType, string> = {
      error: 'wd-bg-red50',
      success: 'wd-bg-green70',
    }
    const alertClass = computed(() => alertClassMap[alertType.value])

    watch(isAlertShown, isShown => {
      if (isShown) {
        return
      }
      alertStore.clearAlert()
    })

    return { isAlertShown, alertClass, hideAlert, alertText }
  },
})
</script>

<style lang="scss" scoped>
@use '@/assets/sass/modules/_animations.scss' as *;
</style>
